<template name="dialog-confirm">
	<div class="choose-scene">
		<el-dialog
		  title="选择商品使用场景"
		  :visible.sync="show"
		  :before-close="close"
		  :close-on-click-modal="false"
		>
			<div>
				<div v-if="category_id == 0 && scene.length <= 0" class="scene-empty-box">
					<div>
						<img src="../../assets/img/promotion/ztd_empty.png">
						<div>没有可选择的使用场景，您可前往场景库添加</div>
					</div>
				</div>
				
				<div v-else class="dia-scene-wrap">
					<div class="dia-scene-nav-box">
						<el-tree
							:data="category" 
							:props="defaultProps" 
							@node-click="handleNodeClick" 
							:default-expanded-keys="defaultShowKey"
							ref="treeSelect"
							node-key="value"
							highlight-current>
						</el-tree>
					</div>
					<div class="dia-scene-item-box">
						
						<div v-if="scene.length <= 0" class="scene-empty-box">
							<div>
								<img src="../../assets/img/promotion/ztd_empty.png">
								<div>当前分组没有可选择的使用场景</div>
								<div>您可前往场景库添加</div>
							</div>
						</div>
						
						<el-checkbox-group v-else class="dia-scene-check" v-model="checks">
							<div class="dia-scene-item"  v-for="item in scene">
								<el-checkbox :label="item.id">
									<div class="dia-scene-label">{{item.label}}</div> 
								</el-checkbox>
							</div>
						</el-checkbox-group>
					</div>
				</div>
			</div>
			
			<div slot="footer" v-if="!(category_id == 0 && scene.length <= 0)" >
				<span class="dia-scene-count">已选{{checks.length}}个场景</span>
				<el-button style="width: 96px;" type="primary" @click="confirm" :disabled="disabled">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAllCategory
	} from '@/api/depot_category';
	import {
		getAllScene,
		getSceneInfoByIds
	} from '@/api/deopt_scene';
	
	
	export default {
		data() {
			return {
				defaultShowKey: [0],
				category_id: 0,
				checks: [],
				category: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				},
				scene:[],
				disabled: false
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			ids: {
				type: Array,
				default: []
			}
		},
		watch:{
			show: function(newVal, oldVal){
				if(newVal){
					this.checks = this.ids;
					this.getCategory();
				}
			}
		},
		methods: {
			// 点击节点
			handleNodeClick(e){
				if(this.category_id == e.value){
					return;
				}
				this.category_id = e.value;
				
				// 调用接口获取数据
				this.getScene();
			},
			_reset(){
				this.category_id = 0;
				this.category = [];
				this.scene = [];
				this.checks = [];
				this.disabled = false;
			},
			close() {
				this.$emit('close');
				this._reset()
			},
			confirm() {
				var checks = this.checks
				if(checks.length <= 0){
					this.$emit('success',[]);
					this._reset()
				}else{
					getSceneInfoByIds({
						ids: JSON.stringify(checks)
					}).then(res => {
						if (res.code == 0) {
							this.$emit('success',res.data);
							this._reset()
						} else {
							this.$message.error(res.message);
						}
					})
				}
			},
			getCategory() {
				var that = this;
				getAllCategory({
					type: 3
				}).then(res => {
					if (res.code == 0) {
						this.category_id = res.data[0].value;
						this.category = res.data;
						this.getScene();
						
						setTimeout(function(){
							that.$refs['treeSelect'].setCurrentKey(0)
						},100)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			getScene() {
				getAllScene({
					category_id: this.category_id
				}).then(res => {
					if (res.code == 0) {
						this.scene = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
		},
		mounted() {
		}
	}
</script>

<style>
	.choose-scene  .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
	}
	.choose-scene  .el-dialog {
		width: 600px;
	}
	.choose-scene  .el-dialog__footer {
		padding-top: 0;
		padding-bottom: 16px;
	}
		
	.scene-empty-box {
		margin: 0 auto;
		min-height: 340px;
		text-align: center;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		color: #999999;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.scene-empty-box img{
		width: 126px;
		display: block;
		margin: 0 auto 10px auto;
	}
	
	
	.dia-scene-wrap{
		display: flex;
		min-height: 340px;
	}
	
	/* 树形结构 */
	.dia-scene-nav-box{
		width: 200px;
		max-height: 340px;
		border-right: 1px solid #EEEEEE;
		box-sizing: border-box;
		overflow-x: auto;
		overflow-y: auto;
	}
	.choose-scene .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
		background-color: transparent;
		color: #1989FA;
		border-radius: 2px;
	}
	.choose-scene  .el-tree-node__label{
		padding-right: 10px;
	}
	.choose-scene  .el-tree-node__content{
		padding: 4px 0;
	}
	.choose-scene .el-tree-node>.el-tree-node__children{
		overflow: inherit;
	}
	
	.dia-scene-item-box{
		width: 400px;
	}
	.dia-scene-check{
		max-height: 340px;
		overflow-y: scroll;
		scrollbar-width: none; /* firefox */
		-ms-overflow-style: none; /* IE 10+ */
	}
	.dia-scene-check::-webkit-scrollbar {
		display: none; /* Chrome Safari */
	}
	.dia-scene-check .el-checkbox{
		display: flex;
	}
	.dia-scene-item{
		width: 336px;
		background: #F5F5F5;
		border-radius: 4px;
		padding: 10px;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		margin:0 0 10px 15px;
	}
	.dia-scene-item .el-checkbox__inner{
		margin-top: 3px;
	}
	.dia-scene-item .dia-scene-label{
		min-height: 80px;
		width: 290px;
		font-size: 12px;
		font-family: AlibabaPuHuiTi_2_65_Medium;
		color: #333333;
		white-space: break-spaces;
	}
	
	.dia-scene-count{
		font-size: 12px;
		font-family: AlibabaPuHuiTi_2_65_Medium;
		color: #666666;
		margin-right: 10px
	}
</style>